class Permissions{
  static permissions = null;
  static group_permissions_map = {};

  static hasPermission(permission) {
    if(!Permissions.permissions) {
      const user_permissions = Cookies.get('user_permissions')
      Permissions.permissions = (user_permissions && user_permissions != "") ? JSON.parse(Cookies.get('user_permissions')) : [];
    }
    return Permissions.permissions.includes(permission);
  }

  static async hasPermissionForGroup(permission, group_id) {
    let myPromise = new Promise(async (resolve, reject) => {
      
      if(!Permissions.group_permissions_map[group_id]) {
        let res = await fetch(`/admin/groups/${group_id}/permissions`)
        let permissions = await res.json();
        Permissions.group_permissions_map[group_id] = permissions;
      }
      
    
      resolve(Permissions.group_permissions_map[group_id].includes(permission));
    });
    return myPromise;
  }

  static ALL = {
    message_center_view: "message_center:view",
    reports_view: "reports:view",
    admin_dni_view: "admin:dni:view",
    profile_view: "profile:view",
    reports_view: "reports:view",
    message_center_view: "message_center:view",
    message_center_can_send_outbound: "message_center:can_send_outbound",
    admin_all: "admin:all",
    admin_view: "admin:view",
    admin_dni_view: "admin:dni:view",
    admin_dni_edit: "admin:dni:edit",
    admin_super_admin_create: "admin:super_admin:create",
    admin_accounting_admin_create: "admin:accounting_admin:create",
    admin_is_super_admin: "admin:super_admin",
    admin_is_admin: "admin:is_admin",
    admin_groups_can_move_locations: "admin:groups:can_move_locations",
    
    admin_accounting_can_inactivate_group: "admin:accounting:can_inactivate_group",
    admin_accounting_can_activate_group: "admin:accounting:can_activate_group",
    admin_accounting_can_inactivate_location: "admin:accounting:can_inactivate_location",
    admin_accounting_can_activate_location: "admin:accounting:can_activate_location",
    admin_accounting_can_alter_billing_info: "admin:accounting:can_alter_billing_info",
    admin_accounting_accounting_admin_view: "admin:accounting:accounting_admin:view",
    admin_accounting_rate_schedules_edit: "admin:accounting:rate_schedules:edit",
    admin_accounting_billing_runs_view: "admin:accounting:billing_runs:view",
    admin_accounting_billing_invoices_view: "admin:accounting:billing_invoices:view",
    
    admin_developer_view: "admin:developer:view",
    admin_developer_manage_permissions_edit: "admin:developer:manage_permissions:edit",
    admin_developer_industries_edit: "admin:developer:industries:edit",
    admin_developer_call_processing_edit: "admin:developer:call_processing:edit",

    admin_audio_management: "admin:audio_management",
    admin_integration_management: "admin:integration_management",
    admin_user_reports: "admin:user_reports",
    admin_group_phone_management_edit: "admin:group:phone_management:edit",
    
    admin_group_accounting_view: "admin:group:accounting:view",
    admin_group_accounting_edit: "admin:group:accounting:edit",
    admin_group_accounthing_rate_schedules_edit: "admin:group:accounting:rate_schedules:edit",
    call_processor_rescore: "call_processor:rescore",
  }
}

export {Permissions}
